var _polygon;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg106AngleHalf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "10.2,70 10.2,35 30.1,15 69.9,15 89.8,35 89.8,70",
    strokeWidth: 8,
    stroke: "#000",
    fill: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg106AngleHalf);
export default __webpack_public_path__ + "static/media/10-6-angle-half.6bf7d8d4a31384ab58d8a6752040c83a.svg";
export { ForwardRef as ReactComponent };